import ChartBar from '@anm/components/charts/ChartBar';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';

import { CHART_BAR_HEIGHT, CHART_BAR_MARGIN_RIGHT } from '..';
import { analyticsSelectors } from '../../../../../../store/modules/analytics';
import ChartInfoContent from '../ChartInfoContent';
import { RelativeBlock } from '../Wrapper';
import { createTooltips } from '../helpers';
import { ChartContentProps } from '../types';

import { getUniquePlaysLabel } from './helpers';

const ChartContent: FC<ChartContentProps> = ({
  containerRef,
  ...restProps
}) => {
  const chartData = useSelector(state =>
    analyticsSelectors.selectPeriodDataByKey(state, 'plays')
  );
  const isPending = useSelector(analyticsSelectors.selectPeriodDataIsPending);
  const isError = useSelector(analyticsSelectors.selectPeriodDataIsError);
  const isLifetimeEmpty = useSelector(
    analyticsSelectors.selectPeriodDataIsLifetimeEmpty
  );

  const drawTooltipHandler = useCallback(
    props => createTooltips(props)(getUniquePlaysLabel),
    []
  );

  if (!chartData?.length || isPending || isError) {
    return (
      <ChartInfoContent {...{ ...restProps, isPending, isLifetimeEmpty }} />
    );
  }

  return (
    <RelativeBlock>
      <ChartBar
        data={chartData}
        height={CHART_BAR_HEIGHT}
        variant="horizontal"
        maxValueRatio={1.1}
        barsHorizontalPadding={4}
        margin={{ right: CHART_BAR_MARGIN_RIGHT, bottom: 1 }}
        containerRef={containerRef}
        drawTooltipOrLabels={drawTooltipHandler}
      />
    </RelativeBlock>
  );
};

export default ChartContent;
